import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import Navigation from './Navigation';
import config from '../config';

function Header() {
  const { name, title, tagline, education, location, email } = config.personalInfo;
  const { linkedin } = config.socialLinks;
  
  return (
    <header>
      <div className="top-content">
        <div className="header-content">
          <h1>
            <Link to="/">{name}</Link>
          </h1>
          <h2>{title}<span className="header-location"> · {location}</span></h2>
          <p className="tagline">{tagline}</p>
        </div>
        <Navigation />
      </div>
      <div className="bottom-content">
        <SocialLinks />
      </div>
    </header>
  );
}

export default Header; 